import React, {PureComponent} from "react"
import styled from "styled-components"

import {FormattedMessage} from "@irati/utils/lang"
import {Label3} from "@irati/ui/src/Labels"
import Flex from "@irati/ui/src/Flex"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {fontColor} from "@irati/ui/src/global/colors"

const StyledLabel3 = styled(Label3)`
  line-height: 18px;
  color: ${fontColor};
`

interface Props {
  center: boolean
}

class PrivateVisibilityMessage extends PureComponent<Props> {
  render() {
    return (
      <Flex alignItems="center" justifyContent={this.props.center ? "center" : "flex-start"}>
        <Icon icon={IconTypes.eye} marginRight />
        <StyledLabel3><FormattedMessage id="recognition.privateVisibilityMessage" /></StyledLabel3>
      </Flex>
    )
  }
}

export default PrivateVisibilityMessage
